export default __webpack_public_path__ + "static/media/heading-bg.2be9cfb8.png";